export const localI18nData = (isJP: string | boolean) => {
    const service: any = {
        data: {
            flipVersionJPText: '日本語',
            flipVersionEngText: 'English',
            regionBarJPText: '日本語',
        }
    };

    function populateResourceBundleTexts() {

        if (!isJP) {
            populateENTexts();
        } else {
            populateJPTexts();
        }
    }

    function populateJPTexts() {
        service.data.detach = '切り離す';
        service.data.floatMenuTooltip_TOC = '目次';
        service.data.floatMenuTooltip_Labels = '各種タグ';
        service.data.floatMenuTooltip_Back = '戻る';
        service.data.floatMenuTooltip_CopyUrl = 'URLをコピー';
        service.data.save = 'PDFを保存';
        service.data.floatMenuTooltip_Save = 'Save Options';
        service.data.floatMenuTooltip_CV = 'CitiVelocity';
        service.data.floatMenuTooltip_More = '次のアクション';
        service.data.print_main_before = '印刷(PDF - ';
        service.data.print_main_after = 'ページ)';
        service.data.floatMenuTooltip_PrintPrefix = '印刷(PDF - ';
        service.data.floatMenuTooltip_BrowserPrint = '印刷';
        service.data.floatMenuTooltip_PrintSuffix = 'ページ)';
        service.data.globalMarketData = 'グローバル・マーケット・データ';
        service.data.point = 'THE POINT';
        service.data.featured = '注目';
        service.data.keyDataChanges = '主要なデータの変更';
        service.data.copyAsHeadline = '刊行レポートのタイトル・見出し';
        service.data.copyAsURL = '刊行レポートのURL';
        service.data.copyURL = "URLをコピー";
        service.data.copyFigure = "図表をコピー";
        service.data.searchCVResearch = 'Search Citi Research';
        service.data.copyButton = 'コピー';
        service.data.viewMoreFromPoint = 'The Point';
        service.data.backToPoint = 'に戻る';
        service.data.viewMoreFromGlobaliser = 'The Globaliser';
        service.data.backToGlobaliser = 'に戻る';
        service.data.viewMoreFromRoundup = 'The Roundup';
        service.data.backToRoundup = 'に戻る';
        service.data.previous = '既刊号';
        service.data.current = '最新号';
        service.data.editions = 'エディション';
        service.data.editors = 'エディター';
        service.data.editor = 'エディター';
        service.data.authorEditor = '編集';
        service.data.calendar = 'カレンダー';
        service.data.corporate = 'コーポレート';
        service.data.economic = '経済';
        service.data.event = 'イベント';
        service.data.floatMenuTooltip_SaveOptions = 'SAVE OPTIONS';
        service.data.floatMenuTooltip_SaveReport = 'PDFを保存';
        service.data.floatMenuTooltip_SaveToReadingList = 'リーディングリストに保存';
        service.data.floatMenuTooltip_ViewReadingList = 'リーディングリストを見る';
        service.data.floatMenuTooltip_RecentlySaved = 'RECENTLY SAVED';
        service.data.myReadingList = 'My Reading List';
        service.data.showUnread = 'Show Unread';
        service.data.showAll = 'Show All';
        service.data.addToFavorites = 'Add to favorites for offline reading';
        service.data.viewInFullScreen = '全画面表示にするためにはここをクリック';
        service.data.backToStandardView = '通常の画面表示に戻る';
        service.data.citiResearch = 'Citi Research';
        service.data.fpDisclosureHeader1 = 'アナリスト・サーティフィケーション、重要な開示事項、米国以外のリサーチアナリストに関する開示事項については、';
        service.data.fpDisclosureHeader2 = '開示事項のセクション';
        service.data.fpDisclosureHeader3 = 'をご覧ください。';
        service.data.fpDisclosureHeader = 'ｱﾅﾘｽﾄ･ｻｰﾃｨﾌｨｹｰｼｮﾝ､重要な開示事項、米国以外のリサーチアナリストに関する開示事項については､Appendix A-1 をご参照ください｡';
        service.data.contactMeAt = '以下の連絡先への連絡を希望します';
        service.data.contactMessage = 'から以下の連絡先への連絡を希望します';
        service.data.companyModelMessage = 'のカンパニーモデル送付を希望します';
        service.data.Email = 'Eメール';
        service.data.Phone = '電話番号';
        service.data.requestContact = '連絡の依頼';
        service.data.authorSubscribe = '購読する'; 
        service.data.authorSubscribed = '購読済み'; 
        service.data.author_directory = '著者要覧';
        service.data.bookMeeting = '予約する';
        service.data.additionalComments = 'コメント';
        service.data.cancel = 'キャンセル';
        service.data.submit = 'サブミット';
        service.data.pollSubmit = 'サブミット';
        service.data.edit = '修正';
        service.data.citiResearchMultimedia = 'シティ・リサーチ・マルチメディア';
        service.data.pollSourceLine = '読者投票の結果(';
        service.data.pollSourceLineAfter = 'まで実施).';
        service.data.pollExpiryMsg = 'その読者投票の受付は終了しました';
        service.data.dataSummary = '主要データ';
        service.data.earningsEstimates = 'セクション';
        service.data.sections = '業績予想: ';
        service.data.moreSections = 'もっと見る';
        service.data.showLess = '閉じる';
        service.data.reportsToRevisit = '参考レポート';
        service.data.research = '最近のレポート';
        service.data.keytakeaways = '主なポイント';
        service.data.bullBearScenarios = '強気シナリオ/弱気シナリオ';
        service.data.catalystWatch = 'カタリスト・ウォッチ';
        service.data.shortTermView = 'ショートターム・ヴュー';
        service.data.original_link = 'このページを含む元のレポートを見る';
        service.data.updated_original_link = '元のレポートを見る';
        service.data.privacy_policy = 'プライバシー・ステートメント';
        service.data.terms_and_conditions = '利用規約';
        service.data.styleAndFactors = 'スタイル・ファクター';
        service.data.CompatibilityTest = '互換性テスト';
        service.data.copyAsInviewURL = 'インビューのURLをコピー';
        service.data.copyAsInviewHeadline = 'インビューのタイトルと見出しをコピー';
        service.data.tags = 'タグ';
        service.data.addToReadingList = '「あとで読む」に加える';
        service.data.supplyChain = 'Supply Chain';
        service.data.esgMateriality = 'ESGプロフィル';
        service.data.houseViews = '弊社の見通し';
        service.data.whatsTrendingTitle = "WHAT'S TRENDING";
        service.data.RelatedResearch = "RELATED RESEARCH";
        service.data.seeMoreText = "See More";
        service.data.more_citi_express_notes = 'この他のCiti Expressメモ';
        service.data.view_citi_express_notes = 'Citi Expressメモを見る';
        service.data.esgMatrix = 'ESGマトリックス';
        service.data.companyDashboard = "会社ダッシュボード";
        service.data.stylesScoreRelativeToPeers = "ピアとの比較でみるスタイル・スコア";
        service.data.esgMatrixPopupTitle = 'Environmental, Social & Governance (ESG) Profile - JP';
        service.data.analystModel = 'Analyst Model - JP';
        service.data.corporateLogoProdUrl = "https://ir.citi.com/k-ivPxALb574bsDioLnlDhRaHFqjMSE8qOXIk1QmuIDT2YuSwtEUuelGy7_mg-ZyT7VMoIb7Dj0tJbS9ThjSCIdKj_WpjacX";
        service.data.corporateLogoUatUrl = "https://uat.ir.citi.com/ZeXS2L1DUQUjPNQ7TE49Ri0Ks20ZNwRz-yNxP7QN0hxgamV3vC9vFhzS16jnU1bT";
        service.data.keyResearchChanges = 'リサーチの重要な変更';
        service.data.copyFigureTooltip = '図表をコピー';
        service.data.figureCopiedConfirmationTooltip = 'クリップボードに図表をコピー済み';
    }

    function populateENTexts() {
        service.data.detach = 'Detach';
        service.data.floatMenuTooltip_TOC = 'Table of Contents';
        service.data.floatMenuTooltip_Labels = 'Labels';
        service.data.floatMenuTooltip_Back = 'Back';
        service.data.floatMenuTooltip_CopyUrl = 'Copy URL';
        service.data.save = 'Save Report (PDF)';
        service.data.floatMenuTooltip_Save = 'Save Options';
        service.data.floatMenuTooltip_CV = 'CitiVelocity';
        service.data.floatMenuTooltip_More = 'More Actions';
        service.data.print_main_before = 'Print (PDF - ';
        service.data.print_main_after = 'pages)';
        service.data.floatMenuTooltip_PrintPrefix = 'Print (PDF - ';
        service.data.floatMenuTooltip_PrintSuffix = ' pages)';
        service.data.floatMenuTooltip_BrowserPrint = 'Print';
        service.data.globalMarketData = 'Global Market Data';
        service.data.point = 'THE POINT';
        service.data.featured = 'FEATURED';
        service.data.keyDataChanges = 'Key Data Changes';
        service.data.copyAsHeadline = 'Title and Headline';
        service.data.copyAsURL = 'Publication URL';
        service.data.copyURL = "Copy URL";
        service.data.copyFigure = "Copy Figure";
        service.data.searchCVResearch = 'Search Citi Research';
        service.data.copyButton = 'Copy';
        service.data.viewMoreFromPoint = 'View more from';
        service.data.backToPoint = 'The Point';
        service.data.viewMoreFromGlobaliser = 'View more from';
        service.data.backToGlobaliser = 'The Globaliser';
        service.data.viewMoreFromRoundup = 'View more from';
        service.data.backToRoundup = 'The Roundup';
        service.data.previous = 'PREVIOUS';
        service.data.current = 'CURRENT';
        service.data.editions = 'Editions:';
        service.data.editors = 'Editors:';
        service.data.editor = 'Editor:';
        service.data.authorEditor = 'Editor';
        service.data.calendar = 'Calendar';
        service.data.corporate = 'Corporate';
        service.data.economic = 'Economic';
        service.data.event = 'Event';
        service.data.floatMenuTooltip_SaveOptions = 'SAVE OPTIONS';
        service.data.floatMenuTooltip_SaveReport = 'Save Report (PDF)';
        service.data.floatMenuTooltip_SaveToReadingList = 'Save to My Reading List';
        service.data.floatMenuTooltip_ViewReadingList = 'View My Reading List';
        service.data.floatMenuTooltip_RecentlySaved = 'RECENTLY SAVED';
        service.data.myReadingList = 'My Reading List';
        service.data.showUnread = 'Show Unread';
        service.data.showAll = 'Show All';
        service.data.addToFavorites = 'Add to favorites for offline reading';
        service.data.viewInFullScreen = 'Click to View in Full Screen';
        service.data.backToStandardView = 'Back to Standard View';
        service.data.citiResearch = 'Citi Research';
        service.data.fpDisclosureHeader1 = 'See ';
        service.data.fpDisclosureHeader2 = 'Disclosures section';
        service.data.fpDisclosureHeader3 = 'for Analyst Certification, Important Disclosures and non-US research analyst disclosures.';
        service.data.fpDisclosureHeader = 'See Appendix A-1 for Analyst Certification, Important Disclosures and non-US research analyst disclosures.';
        service.data.contactMeAt = 'Please contact me at:';
        service.data.contactMessage = '';
        service.data.companyModelMessage = '';
        service.data.Email = 'Email';
        service.data.Phone = 'Phone';
        service.data.requestContact = 'Request Contact';
        service.data.authorSubscribe = 'Subscribe';
        service.data.authorSubscribed = 'Subscribed';
        service.data.author_directory = 'Author Directory';
        service.data.bookMeeting = 'Book Meeting';
        service.data.additionalComments = 'Additional Comments　';
        service.data.cancel = 'CANCEL';
        service.data.submit = 'SUBMIT';
        service.data.pollSubmit = 'Submit';
        service.data.edit = 'Edit';
        service.data.citiResearchMultimedia = 'Citi Research Multimedia';
        service.data.pollSourceLine = 'Readers\' poll results (open through ';
        service.data.pollSourceLineAfter = ').';
        service.data.pollExpiryMsg = 'The selected poll has now expired';
        service.data.dataSummary = 'Data Summary';
        service.data.earningsEstimates = 'Earnings Estimates';
        service.data.sections = 'Sections: ';
        service.data.moreSections = 'More Sections';
        service.data.showLess = 'Show Less';
        //service.data.reportsToRevisit = 'Reports to Revisit';
        service.data.research = 'Recent Research';
        service.data.keytakeaways = 'Key Takeaways';
        // service.data.bullBearScenarios = 'Bull/Bear Scenarios';
        service.data.bullBearScenarios = 'Bull/Bear';
        service.data.catalystWatch = 'Catalyst Watch';
        service.data.shortTermView = 'Short-Term View';
        service.data.keyResearchChanges = 'Key Research Changes';
        service.data.globalThemeMachine = 'Global Theme Machine';
        service.data.original_link = 'View original report containing this page';
        service.data.updated_original_link = 'View original report';
        service.data.privacy_policy = 'Privacy Statement';
        service.data.terms_and_conditions = 'Terms of Use';
        service.data.styleAndFactors = 'Styles & Factors';
        service.data.CompatibilityTest = 'Compatibility Test';
        service.data.copyAsInviewURL = 'Copy InView URL';
        service.data.copyAsInviewHeadline = 'Copy InView Title and Headline';
        service.data.tags = 'Tags';
        service.data.addToReadingList = 'Add to Reading List';
        service.data.supplyChain = 'Supply Chain';
        service.data.esgMateriality = 'ESG Profile';
        service.data.houseViews = 'House Views';
        service.data.whatsTrendingTitle = "WHAT'S TRENDING";
        service.data.RelatedResearch = "RELATED RESEARCH";
        service.data.seeMoreText = "See More";
        service.data.more_citi_express_notes = 'More Citi Express notes';
        service.data.view_citi_express_notes = 'View Citi Express notes';
        service.data.esgMatrix = 'ESG Matrix';
        service.data.companyDashboard = "Company Dashboard";
        service.data.stylesScoreRelativeToPeers = "Styles Score vs Peers";
        service.data.esgMatrixPopupTitle = 'Environmental, Social & Governance (ESG) Profile';
        service.data.analystModel = 'Analyst Model';
        service.data.corporateLogoProdUrl = "https://ir.citi.com/k-ivPxALb574bsDioLnlDhRaHFqjMSE8qOXIk1QmuIDT2YuSwtEUuelGy7_mg-ZyT7VMoIb7Dj0tJbS9ThjSCIdKj_WpjacX";
        service.data.corporateLogoUatUrl = "https://uat.ir.citi.com/ZeXS2L1DUQUjPNQ7TE49Ri0Ks20ZNwRz-yNxP7QN0hxgamV3vC9vFhzS16jnU1bT";
        service.data.copyFigureTooltip = 'Copy Figure';
        service.data.figureCopiedConfirmationTooltip = 'Figure has been copied to the clipboard';
    }

    populateResourceBundleTexts();

    return service;
};
